import React from "react";
import Immutable from "immutable";

export const AppContext = React.createContext(Immutable.Map({
  routingMap: {},
  navTree: [],
  user: {}
}));